import { useEffect } from 'react';

import { yaNative } from '@weberus/ui/utils/ya-native';
import type { SwipeBackParam } from '@weberus/ui/utils/ya-native';

const DEFAULT_MODE = { mode: 'close' } as const;
/**
 * 페이지 컴포넌트에서 사용하는 메소드로 웹뷰의 SwipeBack 기본값을 설정한다.
 * @param option
 *
 *  * IOS SwipeBack 지원 여부를 결정하기 위해 처리하기 위해 사용되는 옵션
 *  *
 *  * @link {https://yanolja.atlassian.net/wiki/spaces/FEDEV/pages/121274385/DONE+Next+PDP+Swipe} 개발문서
 *  * @link {https://yanolja.atlassian.net/wiki/spaces/platformdiv/pages/90613391/Next+PDP+RDP+Swipe+Back} AC 문서
 */
export const useInitSwipeBackOption = (option?: SwipeBackParam): void => {
  const _option = option || DEFAULT_MODE;
  useEffect(() => {
    if (!yaNative.isEnabled) return;
    yaNative.setSwipeBack(_option);
  }, [_option]);
};
